/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:991.98px){.about-logo[_ngcontent-%COMP%]{max-width:40vw}}@media (min-width:576px){.about-logo[_ngcontent-%COMP%]{max-width:20vw}}@media (min-width:992px){.about-logo[_ngcontent-%COMP%]{max-width:11vw}}.about-video[_ngcontent-%COMP%]{max-width:35vw}@media (max-width:1199.98px){.about-video[_ngcontent-%COMP%]{max-width:90vw}}"];
export { styles as styles };
